/***
 * 创建人：ls
 * 时间：2019-08-06
 * 描述：验证数值
 */
import { Directive } from '@angular/core';
import { AbstractControl } from '@angular/forms';
@Directive({
    selector: '[appValidatorNumber]'
})
export class ValidatorNumberDirective {

    constructor() { }

    validateNumber(type: number) {
        return (control: AbstractControl) => {
            let reg;
            switch (type) {
                case 0: reg = /^[1-9]\d*$/;   //正整数
                    break;
                case 1: reg = /^((\d+\.\d{1,2})|(\d+))$/; //至多包含两位小数且大于零的数值
                    break;
            }
            let v = control.value;
            if (!v || v == "") {
                return null;
            } else {
                if (!reg.test(v)) {
                    return {
                        isNumber: true
                    };
                } else {
                    return null;
                }
            }
        }
    }
}

